import script from "./partner.vue?vue&type=script&setup=true&lang=js"
export * from "./partner.vue?vue&type=script&setup=true&lang=js"

import "./partner.vue?vue&type=style&index=0&id=35c68aea&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c68aea"]])

export default __exports__